import React from 'react';

const LogoOutlookSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.6 2L2 4.8v14.3L13.6 22V2zM7.8 9.6C6.8 9.6 6 10.7 6 12c0 1.3.8 2.4 1.8 2.4s1.8-1.1 1.8-2.4c0-1.4-.8-2.4-1.8-2.4zm0-2c1.9 0 3.4 2 3.4 4.4 0 2.4-1.5 4.4-3.4 4.4s-3.4-2-3.4-4.4c0-2.5 1.5-4.4 3.4-4.4zM22 9.5l-5.2 4.6-2.4-2.2v6h6.4c.7 0 1.2-.5 1.2-1.2V9.5zm-1.2-2.7h-6.4v3.5l2.4 2.1 5.1-4.7c-.1-.6-.6-.9-1.1-.9z"
        />
    </svg>
);

LogoOutlookSvg.displayName = 'LogoOutlookSvg';
export default LogoOutlookSvg;
